// Shared FAQ data used by the FAQ page and the footer accordion.
// Keep ordering consistent between both surfaces.
export const FAQS = [
  {
    q: 'How long does a custom order take?',
    a: 'Most custom pieces are completed within 1–3 weeks depending on design complexity and current order volume.',
  },
  {
    q: 'Can I customize colors and design details?',
    a: 'Yes. Every custom piece can be personalized with colors, names, quotes, and custom details.',
  },
  {
    q: 'Do you ship across Canada?',
    a: 'Yes. We ship across Canada and selected international locations.',
  },
  {
    q: 'Are all pieces handmade?',
    a: 'Yes. Every artwork is handcrafted individually in Vancouver.',
  },
  {
    q: 'Can I order personalized gifts?',
    a: 'Absolutely. We create personalized gifts for birthdays, anniversaries, weddings, and special occasions.',
  },
  {
    q: 'Can I request a completely custom design?',
    a: "Yes. Share your ideas and inspiration and we'll create something uniquely yours.",
  },
  {
    q: 'What sizes are available?',
    a: 'We offer multiple sizes and custom dimensions depending on the artwork and your space requirements.',
  },
  {
    q: 'Can I use my own photo or inspiration image?',
    a: "Yes. You can share reference images, ideas, colors, or inspiration and we'll create something unique around your vision.",
  },
  {
    q: 'How should I care for resin artwork?',
    a: 'Gently clean with a soft microfiber cloth and avoid harsh chemicals or prolonged direct sunlight.',
  },
  {
    q: 'How do I start a custom order?',
    a: 'Simply click "Create Your Custom Piece", share your ideas, and we\'ll guide you through the process.',
  },
  {
    q: 'How do I contact you?',
    a: 'Reach out through our contact form, email, or Instagram.',
  },
];

export default FAQS;
